import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Paymentterm } from './paymentterm';
 import { environment } from '../environments/environment';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
 
@Injectable({
  providedIn: 'root'
})
export class PaymenttermService {
  
    baseUrl = environment.baseUrl;
    private paymenttermUrl = this.baseUrl + '/api/paymentterm';  // URL to web api

  constructor( 
    private http: HttpClient
  ) { }

  getPaymentterms (): Observable<Paymentterm[]> {
    return this.http.get<Paymentterm[]>(this.paymenttermUrl)
  }
  getPaymentterm(paymenttermid: number): Observable<Paymentterm> {
    const url = `${this.paymenttermUrl}/${paymenttermid}`;
    return this.http.get<Paymentterm>(url);
  }
  
  addPaymentterm (paymentterm: Paymentterm): Observable<Paymentterm> {
    return this.http.post<Paymentterm>(this.paymenttermUrl, paymentterm, httpOptions);
  }
 
  deletePaymentterm (paymentterm: Paymentterm | number): Observable<Paymentterm> {
    const paymenttermid = typeof paymentterm === 'number' ? paymentterm : paymentterm.paymenttermid;
    const url = `${this.paymenttermUrl}/${paymenttermid}`;
 
    return this.http.delete<Paymentterm>(url, httpOptions);
  }
 
  updatePaymentterm (paymentterm: Paymentterm): Observable<any> {
    return this.http.put(this.paymenttermUrl, paymentterm, httpOptions);
  }

  getrequester (): Observable<Paymentterm[]> {
    return this.http.get<Paymentterm[]>(this.baseUrl +'/api/requester')
  }
 
}